const limit = 100;
const pageSize = 15;
export let maxPage = sessionStorage.getItem("maxPage") || 0;

async function getCurrencies(currentPage) {
  const url = `https://api.coincap.io/v2/assets?offset=${
    currentPage * limit
  }&limit=${limit}`;
  const response = await fetch(url);
  const data = await response.json();
  const length = data.data.length;
  if (length) {
    if (length < limit) {
      maxPage = Math.ceil((currentPage * limit + length) / pageSize);
      sessionStorage.setItem("maxPage", maxPage);
      localStorage.setItem("maxPage", maxPage);
    } else {
      getCurrencies(currentPage + 1);
    }
  } else {
    maxPage = Math.ceil(((currentPage - 1) * limit + limit) / pageSize);
    sessionStorage.setItem("maxPage", maxPage);
    localStorage.setItem("maxPage", maxPage);
  }
}

if (maxPage === 0) {
  getCurrencies(0);
}
